import __base_store from '@/store/__base_store'

/**
 * Store de IVA de comprobantes AFIP de orden de proveedor.
 */
export default __base_store({
	state: {
		model_name: 'provider_order_afip_ticket_iva',
	},
})

